import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuthStore } from '@/store/authStore';
import api from '@/services/api';
import toast from 'react-hot-toast';
import PasswordInput from '@/components/PasswordInput';

export default function RegisterPage() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);

  const [form, setForm] = useState({
    full_name: '',
    email: '',
    password: '',
    password_confirm: '',
  });
  const [loading, setLoading] = useState(false);

  const update = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (form.password !== form.password_confirm) {
      toast.error('Le password non corrispondono');
      return;
    }

    setLoading(true);

    try {
      const { data } = await api.post('/auth/register', {
        full_name: form.full_name,
        email: form.email,
        password: form.password,
      });
      setAuth(data.user, data.tokens.access_token, data.tokens.refresh_token);
      toast.success('Registrazione completata!');
      navigate('/dashboard', { replace: true });
    } catch (err: unknown) {
      const message =
        (err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
        'Errore durante la registrazione';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Registrati — React-City</title>
      </Helmet>

      <h2 className="text-2xl font-bold text-center mb-6">Crea un account</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="full_name" className="label">Nome completo</label>
          <input
            id="full_name"
            type="text"
            className="input"
            placeholder="Mario Rossi"
            value={form.full_name}
            onChange={update('full_name')}
            required
            autoComplete="name"
            autoFocus
          />
        </div>

        <div>
          <label htmlFor="email" className="label">Email</label>
          <input
            id="email"
            type="email"
            className="input"
            placeholder="mario@esempio.it"
            value={form.email}
            onChange={update('email')}
            required
            autoComplete="email"
          />
        </div>

        <div>
          <label htmlFor="password" className="label">Password</label>
          <PasswordInput
            id="password"
            className="input"
            placeholder="Minimo 8 caratteri"
            value={form.password}
            onChange={update('password')}
            required
            autoComplete="new-password"
            minLength={8}
          />
        </div>

        <div>
          <label htmlFor="password_confirm" className="label">Conferma password</label>
          <PasswordInput
            id="password_confirm"
            className="input"
            placeholder="Ripeti la password"
            value={form.password_confirm}
            onChange={update('password_confirm')}
            required
            autoComplete="new-password"
            minLength={8}
          />
        </div>

        <button
          type="submit"
          className="btn-primary w-full"
          disabled={loading}
        >
          {loading ? 'Registrazione...' : 'Registrati'}
        </button>
      </form>

      <p className="text-center text-sm text-surface-500 mt-6">
        Hai già un account?{' '}
        <Link to="/login" className="font-medium text-primary-600">
          Accedi
        </Link>
      </p>
    </>
  );
}
